export const CANCELED = 1;

export const INVALID = 2;
